// extracted by mini-css-extract-plugin
export default {"chipContainer":"Chip__chipContainer___sDhwf","chipIcon":"Chip__chipIcon___cUyQM","chipCloseIcon":"Chip__chipCloseIcon___dD6ZX","chipLabel":"Chip__chipLabel___P3jcT"};